'use client';

import React, { forwardRef } from 'react';
import * as Styled from './TwoColContainer.styled';
import { IComponentContainer } from '../ComponentContainer/ComponentContainer';
import {
  TTypographyColor,
  TTypographyTag,
  Typography,
} from '../Typography/Typography';
import { TTextMultilanguage } from '@/types/global';

export type TContainerColumns = 'small-wide' | 'wide-small' | 'single';

interface ITwoColContainer extends IComponentContainer {
  borderTop?: boolean;
  paddingTop?: 'inner' | 'none' | 'inner-xl';
  paddingTopMobile?: boolean;
  marginBottomSideTitleMobile?: boolean;
  children?: React.ReactNode;
  sideTitle?: TTextMultilanguage | string;
  addColIfNoSideText?: boolean;
  sideTextTag?: TTypographyTag;
  isSideAnimated?: boolean;
  isInverted?: boolean;
  colorSideText?: TTypographyColor;
}

export const TwoColContainer = forwardRef<HTMLDivElement, ITwoColContainer>(
  (
    {
      width = 'main',
      borderTop = false,
      paddingTop = 'none',
      paddingTopMobile = true,
      isProject = false,
      className = '',
      id = '',
      sideTitle,
      addColIfNoSideText = false,
      sideTextTag = 'h2',
      colorSideText = 'primary',
      isSideAnimated = false,
      isInverted = false,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <Styled.TwoColContainer
        width={width}
        pageType={isProject ? 'project' : 'page'}
        borderTop={borderTop}
        className={`${className} two-col-container ${sideTitle ? 'has-title' : 'empty-side'} ${borderTop ? 'has-border-top' : 'no-border-top'}`}
        paddingTop={paddingTop}
        paddingTopMobile={paddingTopMobile}
        isInverted={isInverted}
        ref={ref}
        id={id}
        {...props}
      >
        {sideTitle ? (
          <Styled.SideText>
            <Typography
              text={sideTitle}
              color={colorSideText ?? 'primary'}
              fontFamily="helvetica-regular"
              className="side-text"
              animation={{ type: isSideAnimated ? 'fadeInAndUp' : 'none' }}
              as={sideTextTag}
              size="lg"
            />
          </Styled.SideText>
        ) : addColIfNoSideText ? (
          <div></div>
        ) : (
          <></>
        )}
        {children}
      </Styled.TwoColContainer>
    );
  }
);

TwoColContainer.displayName = 'TwoColContainer';
